export default "__VITE_ASSET__CUIsDBvm__"